<template>
  <div class="placeholder">
    <slot v-for="index in count">
      <p class="text text-75"></p>
      <p class="text text-full"></p>
      <p class="text text-50"></p>
      <p class="text text-50"></p>
      <p class="text text-50"></p>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'ContentPlaceholder',
    props: {
      count: {
        type: Number,
        default: 1,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ContentPlaceholder.vue